import { SortingSelector } from 'searchkit';

export default class CustomSortingSelector extends SortingSelector {

    toggleItem = (key) => {
        this.accessor.state = this.accessor.state.setValue(key);
        this.searchkit.performSearch();
        this.props.onChange(key);
    };

    componentDidUpdate(prevProps) {
        const sortKey = this.accessor.getSelectedOption().key;
        if (this.props.sortKey !== prevProps.sortKey || sortKey !== this.props.sortKey) {
            this.props.onChange(sortKey);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/page/search/components/CustomSortingSelector.js